export enum ChoiceOrdering {
  ALPHABETICAL = 'ALPHABETICAL',
  RANDOM = 'RANDOM',
  BY_POSITION = 'BY_POSITION',
}
